export default __webpack_public_path__ + "static/media/d5.9f9c20de.jpg";